import AlertIcon from "@assets/icons/alert-icon.svg";

import { BackgroundSection } from "@components/Sections";
import { MainLogo } from "@ui/Logos/MainLogo";
import { Paragraph } from "@ui/Content";
import { H3 } from "@ui/Headings";

export default function SyncDisabledScreen() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-[100px]">
        <MainLogo className="pb-[50px]" />

        <div className="relative w-full">
          <BackgroundSection
            className="bg-yellow-100"
            icon={<AlertIcon className="text-yellow-500" />}
          />
        </div>

        <div className="flex flex-col gap-3 items-center w-80 px-4 mt-5">
          <H3 className="text-teal-600 dark:text-teal-400">
            Sync disabled for this sender
          </H3>
          <Paragraph>
            This email involves an address that is excluded from CRM syncing in your Meridian system settings.
          </Paragraph>
        </div>
      </div>
    </div>
  );
}
